import { useQuery } from "@tanstack/react-query";
import { tenantQueries } from "@/domains/tenant/queries";
import { useSession } from "@/platform/auth";

export function useTenant() {
  const { user } = useSession();
  return useQuery(tenantQueries.current(user?.id));
}
